/// <amd-module name="VSS/Redux/Modules/ContentViewObserver/ContentViewObserverSaga" />
import { effects, SagaIterator } from "redux-saga";
import { ActionsOfType } from "redux/Utils/ActionHelper";
import { IObservableValue } from "VSS/Core/Observable";
import { IVssPageContext } from "VSS/Platform/Context";
import { ISettingsService, SettingsUserScope } from "VSS/Platform/Settings";
import { createObservableSaga } from "VSS/Redux/Utils/ObservableUtils";
import { FILTER_CHANGE_EVENT, IFilter } from "VSSUI/Utilities/Filter";
import { ContentViewObserverActions, ContentViewObserverActionTypes } from "./ContentViewObserverActions";
import { IContentViewObserverModuleArgs, IFilterDetails } from "./ContentViewObserverContracts";
import { getFilterDetails, isFilterActive } from "./ContentViewObserverSelectors";

export function* filterObserverSaga(args?: IContentViewObserverModuleArgs): SagaIterator {
    if (!args) {
        return;
    }
    const { filterArgs, selectedTab } = args;

    if (filterArgs && filterArgs.filter && filterArgs.filterToggled) {
        const { filter, filterToggled } = filterArgs;
        yield effects.fork(createObservableSaga(filter, { [FILTER_CHANGE_EVENT]: ContentViewObserverActions.filterStateChanged }));

        yield effects.fork(createObservableSaga(filterToggled, ContentViewObserverActions.filterToggled));

        // Filter values are usually deserialized by the pivot, listen to InitializeFilterState to see the filter
        yield effects.takeEvery(ContentViewObserverActionTypes.InitializeFilterState, updateFilterStateInObservable, filter, filterToggled);
        yield effects.takeEvery(ContentViewObserverActionTypes.FilterStateChanged, storeFilterData);
    }

    if (selectedTab) {
        yield effects.put(ContentViewObserverActions.initializeSelectedPivot(selectedTab.value));
        yield effects.fork(createObservableSaga(selectedTab, ContentViewObserverActions.selectedPivotChanged));
    }
}

function* updateFilterStateInObservable(
    filter: IFilter,
    filterToggled: IObservableValue<boolean>,
    action: ActionsOfType<ContentViewObserverActions, ContentViewObserverActionTypes.InitializeFilterState>
) {
    const {
        filterDetails: { filterState, filterVisible }
    } = action.payload;
    filter.setState(filterState);
    filterToggled.value = filterVisible;
}

function* storeFilterData() {
    const filterDetails: IFilterDetails = (yield effects.select(getFilterDetails)) as any;
    const isActive = (yield effects.select(isFilterActive)) as any;

    const { filterKey, filterState, projectId } = filterDetails;
    const pageContext: IVssPageContext = (yield effects.getContext("pageContext")) as any;
    const settingsService = pageContext.getService<ISettingsService>("ISettingsService");

    if (!isActive) {
        // Clear stored settings
        yield effects.call([settingsService, settingsService.setEntries], { [filterKey]: "" }, SettingsUserScope.Me, "Project", projectId);
    } else {
        const settings = {
            [filterKey]: JSON.stringify(filterState)
        };
        yield effects.call([settingsService, settingsService.setEntries], settings, SettingsUserScope.Me, "Project", projectId);
    }
}
